/**
 * Stripe publishable key — hydrated at boot from GET /api/health (same
 * pattern as the concierge fee, #31). Publishable keys are public by design;
 * null means dev/sim (no key set server-side) and consumers degrade —
 * the signup wizard's address step falls back to manual structured fields.
 */
export let STRIPE_PUBLISHABLE_KEY: string | null = null

export function hydrateStripeKey(key: unknown): void {
  if (typeof key === 'string' && key.startsWith('pk_')) STRIPE_PUBLISHABLE_KEY = key
}
